const getWeekInfo = ({ selectedYearMonth, showWeek, firstWeek }) => {
  const selectedYear = parseInt(selectedYearMonth?.slice(0, 4));
  const selectedMonth = parseInt(selectedYearMonth?.slice(5, 7)) - 1;
  const firstDayOfTheMonth = new Date(selectedYear, selectedMonth, 1).getDay();
  const lastDate = new Date(selectedYear, selectedMonth + 1, 0).getDate();
  const weeksInMonth = Math.ceil(lastDate / 7);

  const isFirstWeek = showWeek === firstWeek;
  const isLastWeek = showWeek === weeksInMonth;

  return { firstDayOfTheMonth, weeksInMonth, lastDate, isFirstWeek, isLastWeek };
};

export default getWeekInfo;
